import { commonStyles, buttonStyle } from "src/Library/CommonStyles";
import { tokens } from 'src/design-system';

export const ChargeListCardsStyles = (theme) => ({
  mainDiv: {
    width: '96%',
    marginBottom: tokens.spacing.ms,
    border: `1px solid ${tokens.colors.border}`,
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.colors.bgWhite,
  },
  rateCard: {
    height: '80px',
    padding: '0 14px',
    display: 'flex',
    alignItems: 'center',
  },
  carrierLogo: {
    maxWidth: '100px',
    // height: 'auto',
    maxHeight: '50px',
  },
  portDetail: {
    fontSize: tokens.fontSize.h2,
    fontWeight: tokens.fontWeight.semibold,
    marginLeft: '5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '18ch'
  },
  portState: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textSecondary,
    marginLeft: '5px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '18ch',
  },
  line: {
    display: 'flex',
    flex: 1,
    height: 1,
    backgroundColor: '#58C7EC',
  },
  dot: {
    height: '6px',
    width: '6px',
    borderRadius: '5px',
    display: 'inline-block',
    border: `1px solid ${tokens.colors.textSecondary}`,
  },
  lineAndDot: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  flexDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  route: {
    display: 'flex',
    width: '30%',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: tokens.fontWeight.semibold,
    marginTop: '5px',
  },
  border: {
    borderRight: `1px solid ${tokens.colors.border}`,
    borderLeft: `1px solid ${tokens.colors.border}`,
    height: '60px',
  },
  borderLeft: {
    // borderRight: `1px solid ${tokens.colors.border}`,
    borderLeft: `1px solid ${tokens.colors.border}`,
    height: '60px',
  },
  borderRight: {
    borderRight: `1px solid ${tokens.colors.border}`,
    // borderLeft: `1px solid ${tokens.colors.border}`,
  },
  chargeDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    fontWeight: tokens.fontWeight.semibold,
  },
  currency: {
    fontSize: tokens.fontSize.caption,
    verticalAlign: 'top',
    lineHeight: '22px',
  },
  bottomDiv: {
    cursor: 'pointer',
    borderRadius: '0px 0px 3px 3px',
  },
  bottomCard: {
    fontSize: tokens.fontSize.caption,
    paddingRight: '15px',
    display: 'flex',
    alignItems: 'center',
  },
  transitDays: {
    fontSize: tokens.fontSize.caption,
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
  },
  chargesDiv: {
    backgroundColor: '#FDFDFD',
    fontSize: tokens.fontSize.small,
    padding: `${tokens.spacing.sm}px ${tokens.spacing.md}px 36px ${tokens.spacing.md}px`,
    borderTop: `1px solid ${tokens.colors.border}`,
    cursor: 'default',
  },
  rightAlign: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '18px',
  },
  viewHideDetails: {
    color: tokens.colors.primaryDark,
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.caption,
    cursor: 'pointer',
    padding: '4px 0 2px'
  },
  chargeBreakdownCurrency: {
    fontSize: '9px',
    lineHeight: '16px',
    verticalAlign: 'top',
  },
  pricePerUnitRow: {
    display: 'inline-flex',
    alignItems: 'baseline',
    gap: '4px',
    whiteSpace: 'nowrap',
  },
  unitType: {
    fontSize: '8px',
    color: tokens.colors.textTertiary,
  },
  chargeBreakdownGrid: {
    display: 'grid',
    gridTemplateColumns: '20.833% 29.167% 12.5% 12.5% 25%',
    width: '100%',
  },
  chargeBreakdownHeader: {
    borderBottom: '1px solid #f0f0f0',
    color: '#666',
    fontSize: '12px',
    fontWeight: 500,
    alignItems: 'center',
  },
  chargeBreakdownRow: {
    alignItems: 'start',
  },
  chargeBreakdownCell: {
    padding: '9px 10px',
    display: 'flex',
    alignItems: 'flex-start',
  },
  chargeBreakdownCellCenter: {
    justifyContent: 'center',
    textAlign: 'center',
  },
  chargeBreakdownCellRight: {
    justifyContent: 'flex-end',
    textAlign: 'right',
  },
  otherDetails: {
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.semibold,
    marginTop: tokens.spacing.sm,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '90%',
  },
  exchangeRate: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: tokens.fontWeight.semibold,
  },
  chargeAmount: {
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textSecondary,
  },
  totalPrice: {
    padding: '10px',
    textAlign: 'right',
    paddingRight: tokens.spacing.md,
  },
  totalPriceRow: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'flex-end',
    gap: '4px',
  },
  totalPriceMeta: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: '4px',
    fontSize: '10px',
    fontStyle: 'italic',
  },
  marginBadge: {
    borderRadius: '2px',
    padding: '2px 4px',
  },
  unitsNo: {
    padding: '10px',
    textAlign: 'center',
  },
  currencyBar: {
    padding: '9px 10px',
    textAlign: 'right',
    paddingRight: tokens.spacing.md,
    borderRadius: tokens.radius.sm,
  },
  totalCharge: {
    fontSize: '19px',
    fontWeight: 'bold',
    color: tokens.colors.textSecondary,
  },
  otherCharges: {
    fontSize: '21px',
    fontWeight: 'bold',
    color: '#555555',
  },
  charges: {
    color: tokens.colors.textSecondary,
    display: 'flex',
    alignItems: 'center',
  },
  subtotal: {
    backgroundColor: 'rgba(227, 211, 169, 0.15)',
    padding: `9px ${tokens.spacing.md}px 9px ${tokens.spacing.md}px`,
    borderRadius: tokens.radius.sm,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '5px',
    fontWeight: tokens.fontWeight.semibold,
    fontSize: tokens.fontSize.body,
  },
  total: {
    backgroundColor: 'rgba(227, 211, 169, 0.5)',
    padding: tokens.spacing.md,
    fontWeight: 'bold',
  },
  chargeName: {
    padding: `9px ${tokens.spacing.md}px 9px ${tokens.spacing.md}px`,
    fontWeight: tokens.fontWeight.semibold,
    borderRadius: tokens.radius.sm,
  },
  reportButton: {
    color: '#2373BD',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  reportIcon: {
    fontSize: tokens.spacing.lg,
    color: '#F6B728',
    marginRight: tokens.spacing.ms,
  },
  modalTitle: {
    fontSize: tokens.fontSize.h3,
    display: 'flex',
    alignItems: 'center',
    fontWeight: tokens.fontWeight.semibold,
  },
  reportModal: {
    maxWidth: '380px',
    '& .ant-modal-body': {
      padding: `${tokens.spacing.md}px ${tokens.spacing.lg}px`,
      fontSize: tokens.fontSize.small,
      fontWeight: tokens.fontWeight.semibold,
    },
    '& .ant-modal-content': {
      '& .ant-modal-close-x': {
        '& .anticon': {
          fontSize: '22px',
        },
      },
    },
    '& .ant-modal-footer': {
      borderTop: 0,
      padding: `${tokens.spacing.sm}px ${tokens.spacing.lg}px ${tokens.spacing.md}px ${tokens.spacing.lg}px`,
    },
  },
  reportSubmit: {
    color: tokens.colors.bgWhite,
    backgroundColor: tokens.colors.primaryDark,
    border: `1px solid ${tokens.colors.primaryDark}`,
    '&:hover': {
      color: tokens.colors.bgWhite,
      backgroundColor: tokens.colors.primaryDark,
      border: `1px solid ${tokens.colors.primaryDark}`,
    },
    '&:focus': {
      color: tokens.colors.bgWhite,
      backgroundColor: tokens.colors.primaryDark,
      border: `1px solid ${tokens.colors.primaryDark}`,
    },
  },
  error: {
    marginBottom: 0,
    '& .has-error .ant-form-explain': {
      fontSize: tokens.fontSize.small,
      fontWeight: 'normal',
      marginTop: '5px',
    },
  },
  carrierInfo: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '14px',
  },
  remarks: {
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.semibold,
    marginTop: tokens.spacing.md,
    wordWrap: 'break-word',
  },
  carrierCode: {
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  transshipmentList: {
    fontSize: tokens.fontSize.caption,
    paddingLeft: '15px',
    marginTop: tokens.spacing.sm,
  },
  tooltipStyle: {
    fontSize: tokens.fontSize.small,
    '& .ant-tooltip-inner': {
      backgroundColor: '#000000',
      color: tokens.colors.bgWhite,
    },
  },
  margin: {
    position: 'absolute',
    padding: `${tokens.spacing.sm}px ${tokens.spacing.xxs}px`,
    right: tokens.spacing.sm,
    textAlign: 'center',
    color: tokens.colors.textSecondary,
    borderRadius: tokens.radius.md,
    ...commonStyles(theme).flexColumn,
    alignItems: 'center',
  },
  marginDivPosition: {
    right: '-11%',
  },
  marginPositive: {
    border: '1px solid #B3DEA6',
    backgroundColor: '#E3FFDB',
  },
  marginNegative: {
    border: '1px solid #EFC4C3',
    backgroundColor: '#FFDFDF',
  },
  noMargin: {
    border: '1px solid #DDDDDD',
    backgroundColor: tokens.colors.bgSubtle,
  },
  marginCurrency: {
    fontSize: '8px',
    verticalAlign: 'top',
    lineHeight: '10px',
  },
  flexRow: {
    ...commonStyles(theme).flexRow,
  },
  totalPriceWithMargin: {
    borderRadius: tokens.radius.md,
    paddingRight: tokens.spacing.md,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '4px',
    justifyContent: 'flex-start',
  },
  selectSLCheckbox: {
    position: 'absolute',
    right: '3px',
    top: '1px',
    '& .ant-checkbox-inner': {
      height: '14px',
      width: '14px',
    },
    '& .ant-checkbox-checked .ant-checkbox-inner': {
      backgroundColor: '#444444',
      borderColor: '#444444',
    },
  },
  shipperOrg: {
    ...commonStyles(theme).ellipses,
    maxWidth: '75%',
    padding: `${tokens.spacing.xs}px 18px ${tokens.spacing.xxs}px ${tokens.spacing.sm}px`,
    borderRadius: '0 40px 0 0',
  },
  bookNowButton: {
    ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primaryDark, `1px solid ${tokens.colors.primaryDark}`),
    borderRadius: tokens.radius.md,
    padding: `0 ${tokens.spacing.md}px`,
    fontSize: tokens.fontSize.small,
  },
  negotiateDiv: {
    position: 'absolute',
    margin: '6px 0 0 5px',
  },
  negotiate: {
    marginTop: tokens.spacing.xs,
    fontSize: tokens.fontSize.small,
    textAlign: 'center',
    cursor: 'pointer',
    textDecoration: 'underline',
    color: '#666666',
  },
  wetPort: {
    fontSize: '8px',
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.semibold,
    ...commonStyles(theme).ellipses,
  },
  routeInfo: {
    ...commonStyles(theme).flexRow,
  },
  title: {
    fontSize: tokens.fontSize.h3,
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
  },
  chargeRow: {
    display: 'flex',
    alignItems: 'flex-start',
  },
});
